import React from "react";
import './loginForm.css'

export default function LoginForm({ isShowLogin, handleSubmitLogin }) {
  return (
    <div className={`${isShowLogin ? "active " : ""}show`}>
        { isShowLogin ? null :
        <div className="show">
          <div className="login-form">
            <div className="form-box solid">
              <form onSubmit={handleSubmitLogin}>
                <h1 className="login-text">Login</h1>
                <input type="text" name="username" className="login-box" placeholder="Usuário"/>
                <input type="password" name="password" className="login-box" placeholder="Senha"/>
                <input type="submit" value="Entrar" className="login-btn" />
              </form>
            </div>
          </div>
        </div>
        }
    </div>
  )
};